import { useGitHubConfig } from './useGitHubConfig.esm.js';

const useUrl = (entity) => {
  const targetProviderConfig = useGitHubConfig(entity);
  const baseUrl = targetProviderConfig?.getOptionalString("apiBaseUrl") || "https://api.github.com";
  const hostname = targetProviderConfig?.getOptionalString("host") || "github.com";
  return {
    hostname,
    baseUrl
  };
};

export { useUrl };
//# sourceMappingURL=useUrl.esm.js.map
